import RMButton from 'components/customComponents/Controls/RMButton';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { browseFileHandler, showAlertSnackBar } from 'utils/Global';
import ImportSynchTripResultContext from './context';
import { useMapData } from './hooks';
import { validateImportCSV } from './utils';
import { IStyle } from 'Styles';

const SynchTripResultFileImport = () => {
  const inputFile = useRef(null);
  useMapData();
  const synchTripContext = useContext(ImportSynchTripResultContext);
  const [fileLabel, setFileLabel] = useState('Select File .csv');
  useEffect(() => {
    synchTripContext.setNextButtonDisallowed(true);
  }, []);

  const fileHandler = async (e) => {
    const result = (await browseFileHandler(e)) as any;
    if (!validateImportCSV(result.data)) {
      showAlertSnackBar(
        EAlertType.ERROR,
        ESnackBarPosition.TOP,
        'Input file is not in correct format.',
      );
      return;
    }
    setFileLabel(result.name);
    synchTripContext.setFileContent(result.data);
    synchTripContext.setNextButtonDisallowed(false);
  };

  const onChooseFile = () => {
    inputFile.current?.click();
  };

  return (
    <div
      id="fileupload-wrapper"
      className="flex flex-xy-center flex-column"
      style={styles.uploadHeading}
    >
      <div id="fileupload-label">
        <label id={`fileupload-${fileLabel}-text`}>{fileLabel}</label>
      </div>
      <div>
        <RMButton
          id='fileupload-browse-button'
          customStyle={styles.browseButton}
          onClick={onChooseFile}
          label="Browse File"
        />
      </div>
      <div id="fileupload-file">
        <input
          id="fileupload-file-input"
          type="file"
          ref={inputFile}
          style={{ display: 'none' }}
          onInput={fileHandler}
        />
      </div>
      <div id="fileupload-message" style={styles.browseText}>
        {`Please select "Browse File" to import .csv file`}
      </div>
    </div>
  );
};
export default SynchTripResultFileImport;

const styles: IStyle = {
  buttonRoot: {
    margin: '10px 0px 0px 0px',
  },
  browseButton: {
    width: '12rem',
    height: '2rem',
    maxHeight: '2rem',
    minHeight: '2rem',
    borderRadius: '0.5rem',
    fontSize: '1.25rem',
    lineHeight: '1.45rem',
    textTransform: 'none',
  },
  browseText: {
    textAlign: 'center',
    color: 'gainsboro',
  },
  uploadHeading: {
    height: '100%',
  },
};
